import { c as _c } from "react/compiler-runtime";
import type * as React from "react";
import { Section } from "~/components/layout/Section";
import { SectionHeader } from "~/components/layout/SectionHeader";
import { cn } from "~/lib/utils";
export type FaqItem = {
  q: string;
  a: string;
};
type FaqSectionProps = {
  items: readonly FaqItem[];
  eyebrow?: string;
  title?: React.ReactNode;
  backgroundClassName?: string;
  id?: string;
};
const DEFAULT_TITLE = <>
    Have questions?{" "}
    <em className="italic text-accent-dark">We have answers.</em>
  </>;
export function FaqSection(t0) {
  const $ = _c(10);
  const {
    items,
    eyebrow: t1,
    title: t2,
    backgroundClassName: t3,
    id
  } = t0;
  const eyebrow = t1 === undefined ? "Frequently asked questions" : t1;
  const title = t2 === undefined ? DEFAULT_TITLE : t2;
  const backgroundClassName = t3 === undefined ? "bg-ink-05" : t3;
  let t4;
  if ($[0] !== eyebrow || $[1] !== title) {
    t4 = <SectionHeader eyebrow={eyebrow} title={title} />;
    $[0] = eyebrow;
    $[1] = title;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== items) {
    t5 = <FaqList items={items} className="mx-auto max-w-[720px]" />;
    $[3] = items;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== backgroundClassName || $[6] !== id || $[7] !== t4 || $[8] !== t5) {
    t6 = <Section id={id} backgroundClassName={backgroundClassName}>{t4}{t5}</Section>;
    $[5] = backgroundClassName;
    $[6] = id;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}

/**
 * The accordion on its own, for pages that lay the FAQ out differently from
 * `FaqSection` (the host landing page puts it beside its title).
 */
export function FaqList(t0) {
  const $ = _c(7);
  const {
    items,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("divide-y divide-divider", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== items) {
    t2 = items.map(_temp);
    $[2] = items;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function _temp(t0) {
  const {
    q,
    a
  } = t0;
  return <FaqItem key={q} question={q} answer={a} />;
}
function FaqItem(t0) {
  const $ = _c(10);
  const {
    question,
    answer
  } = t0;
  let t1;
  if ($[0] !== question) {
    t1 = <span className="font-ui text-sm font-semibold text-body">{question}</span>;
    $[0] = question;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="flex size-6 shrink-0 items-center justify-center rounded-full border border-(--color-border) text-muted transition-transform group-open:rotate-45" aria-hidden="true"><svg viewBox="0 0 12 12" className="h-3 w-3" fill="none" stroke="currentColor" strokeWidth={2} aria-hidden="true"><path d="M6 1v10M1 6h10" strokeLinecap="round" /></svg></span>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <summary className="flex w-full cursor-pointer list-none items-center justify-between gap-4 py-5 text-left [&::-webkit-details-marker]:hidden">{t1}{t2}</summary>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== answer) {
    t4 = <p className="pb-5 font-ui text-sm leading-relaxed text-muted">{answer}</p>;
    $[5] = answer;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <details className="group">{t3}{t4}</details>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}